import React from 'react';
import { NavLink } from 'react-router-dom';
import { 
  LayoutDashboard, 
  Users, 
  BookOpen,
  FileText,
  UserCircle
} from 'lucide-react';

const TeacherSidebar = () => {
  const menuItems = [
    {
      section: 'Asosiy',
      items: [
        { path: '/teacher', icon: LayoutDashboard, label: 'Bosh sahifa', exact: true },
      ]
    },
    {
      section: "Ta'lim",
      items: [
        { path: '/teacher/groups', icon: Users, label: 'Mening guruhlarim' },
        { path: '/teacher/subjects', icon: BookOpen, label: 'Mening fanlarim' },
        { path: '/teacher/materials', icon: FileText, label: 'Materiallar' },
      ]
    },
    {
      section: 'Profil',
      items: [
        { path: '/teacher/profile', icon: UserCircle, label: 'Profilim' },
      ]
    }
  ];

  return (
    <aside className="sidebar teacher-sidebar">
      <div className="sidebar-header">
        <div className="sidebar-logo">
          <div className="sidebar-logo-icon">
            <img src="/logo.png" alt="BXTT" />
          </div>
          <div>
            <h2>BXTT</h2>
            <span>O'qituvchi</span>
          </div>
        </div>
      </div>

      <nav className="sidebar-nav">
        {menuItems.map((section, idx) => (
          <div key={idx} className="nav-section">
            <div className="nav-section-title">{section.section}</div>
            {section.items.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.exact}
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
              >
                <item.icon size={20} />
                <span>{item.label}</span>
              </NavLink>
            ))}
          </div>
        ))}
      </nav>
    </aside>
  );
};

export default TeacherSidebar;
